module.exports = __webpack_public_path__ + "static/media/insta.1a87e07e.webp";